// Centralized default data for landing page sections
export const defaultHeader = {
  logoColor: '#222'
};

export const defaultFirstSection = {
  stackedText: {
    de: ['MÖGL', 'ICHKE', 'ITSRA', 'UM'],
    en: ['POSS', 'IBIL', 'ITIES', 'PACE']
  },
  navText: {
    de: 'IDEE — INSIGHTS',
    en: 'IDEA — INSIGHTS'
  },
  subTitle: {
    de: '',
    en: ''
  },
  modalHeader: {
    de: 'Der  T A F E L B E R G\nim Herzen der Nürnberger Altstadt',
    en: 'IDEA - INSIGHTS\nin the heart of Nuremberg\'s old town'
  },
  backgroundColor: '#ffffff',
  textColor: '#fff',
  stackedTextColor: '#000',
  navTextColor: '#ffffff',
  subTitleColor: '#cccccc',
  modalHeaderColor: '#ffffff',
  cardTitleColor: '#A08B7A',
  cardDescriptionColor: '#fff',
  cards: [
    {
      id: 1,
      description: {
        de: "Der Tafelberg ist das älteste Gerberhaus Deutschlands. Er erwartet seine Gäste in der historischen Weißgerbergasse. Ein einzigartiger\nund inspirierender Rahmen für kleine Gruppen\nund bis zu 40 Personen.\n",
        en: "Tafelberg is Germany's oldest tanner's house. It welcomes its guests in the historic Weißgerbergasse. A unique\nand inspiring setting for small groups\nand up to 40 people.\n"
      }
    },
    {
      id: 2,
      title: {
        de: "Was hier passiert, liegt ganz bei Ihnen.",
        en: "What happens here is entirely up to you."
      },
      description: {
        de: "Seine Erbauer haben den Tafelberg nach\nihren Bedürfnissen errichtet und immer\nwieder umgestaltet. Er war ihnen\nMöglichkeitsraum und Identifikationsort.\nUnd das ist er für seine Gäste auch noch heute.",
        en: "Its builders constructed Tafelberg according\nto their needs and always\nreshaped it. It was their\nspace of possibilities and place of identification.\nAnd that's what it is for its guests even today."
      }
    },
    {
      id: 3,
      title: {
        de: "Exklusiv, eigen, einzigartig.\n",
        en: "Exclusive, own, unique.\n"
      },
      description: {
        de: "Eingebettet in den Lauf fühlen seine Besucher sich geborgen.\nIntensive Gespräche beginnen wie von selbst.",
        en: "Embedded in the course of time, its visitors feel sheltered.\nIntensive conversations begin as if by themselves."
      }
    }
  ]
};

export const defaultArtSection = {
  images: [
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901204/3_jtu8rx.jpg',
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901207/4_wfcbwc.jpg',
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901207/6_ttm7gq.jpg',
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901208/7_nfhle4.jpg',
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901208/5_xsfovw.jpg',
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901203/2_jxqihu.jpg',
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901210/8_avaxkd.jpg',
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901212/9_vgr6rq.jpg',
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901214/10_k6g2e0.jpg',
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901214/11_qqfkfc.jpg',
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901218/12_vv9jjn.jpg',
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901218/13_kin5h4.jpg',
    'https://res.cloudinary.com/dqssg8tws/image/upload/v1769901220/15_in4yo2.jpg',
    '/einzigartig/14.jpg',
    '/einzigartig/15.jpg'
  ],
  fullText: {
    de: `\nUm 1250 wurde der Kern des heutigen Tafelbergs erbaut.\n1372 errichtet ein Gerber sein Fachwerkhaus. Deutschlands ältestes Gerberhaus.\n1945. Der Tafelberg überlebt den Weltkrieg unbeschadet.\nAlle Leben und Phasen sind spürbar und verleihen dem Tafelberg seinen wahrhaftig einzigartigen Charakter.`,
    en: `\nAround 1250, the core of today's Tafelberg was built.\n1372 a tanner built his half-timbered house. Germany's oldest tanner's house.\n1945. Tafelberg survives the Second World War unscathed.\nAll lives and phases are tangible and give Tafelberg its truly unique character.`
  },
  overlayText: {
    de: 'Wir lieben Kunst –\nsie ist wesentlich',
    en: 'We love art –\nit is essential'
  },
  modalTitle: {
    de: 'ART - INSIGHTS',
    en: 'ART - INSIGHTS'
  },
  modalContent: {
    de: 'Hier können Sie tiefere Einblicke in unsere Kunstsammlung, Ausstellungen und exklusive Inhalte erhalten.\nGenießen Sie eine immersive Erfahrung in die Welt der Kunst.',
    en: 'Here you can gain deeper insights into our art collection, exhibitions and exclusive content.\nEnjoy an immersive experience in the world of art.'
  },
  textColor: '#000000',
  remainingTextColor: '#000000',
  overlayTextColor: '#ffffff',
  modalTitleColor: '#fff',
  modalContentColor: '#fff'
};

export const defaultNowSection = {
  images: ['/imjetzt/3.jpg', '/imjetzt/4.jpg', '/imjetzt/1.jpg', '/imjetzt/5.jpg', '/imjetzt/2.jpg'],

  artInsights: {
    de: 'ART - INSIGHTS',
    en: 'ART - INSIGHTS'
  },
  artInsightsContent: {
    de: 'Hier können Sie tiefere Einblicke in unsere Kunstsammlung, Ausstellungen und exklusive Inhalte erhalten.\nGenießen Sie eine immersive Erfahrung in die Welt der Kunst.',
    en: 'Here you can gain deeper insights into our art collection, exhibitions and exclusive content.\nEnjoy an immersive experience in the world of art.'
  },
  buttonText: {
    de: 'EXLUSIV BUCHBAR',
    en: 'IN THE NOW'
  },
  modalTitle: {
    de: 'EXLUSIV BUCHBAR',
    en: 'IN THE NOW'
  },
  modalContent: {
    de: [
        'Unvergessliche Erlebnisse.\n'+
      'Für kleine Gruppen und bis zu 40 Personen.\n' +
      'Auf Wunsch organisieren wir Köche, Service, Performances.\n' +
      '\n' +
      'Kontaktieren Sie uns.'
    ],
    en: [
      'Seize the opportunities.',
      'Unique experiences for small groups and up to 40 people.',
      'On request, we organize chefs, service, performances.',
      'Contact us. We support you and adapt to your wishes.'
    ]
  },
  buttonTextColor: '#ffffff',
  modalTitleColor: '#ffffff',
  modalContentColor: '#ffffff'
};

export const defaultGallerySection = {
  images: [
    '/gallery/1.jpg',
    '/gallery/2.jpg',
    '/gallery/3.jpg',
    '/gallery/4.jpg',
    '/gallery/5.jpg',
    '/gallery/6.jpg'
  ],
  headerTitle: 'Gallery',
  headerSubtitle: 'Explore our creative collection'
};

export const defaultVideosSection = {
  videos: [
    {
      id: 1,
      customer: 'Alice1',
      title: 'Amazing Experience!1',
      thumbnail: 'https://picsum.photos/400/700?random=1',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4',
      comment: 'Loved the ambiance and service. Highly recommended!',
    }
  ],
};

export const defaultContactSection = {
  executionText: 'Execution is the game',
  kontaktLetters: ['K', 'O', 'N', 'T', 'A', 'K', 'T'],
  address: 'Tafelberg | Weißgerbergasse 33 | 90403 Nürnberg',
  phone: 'Tel.: +49 (0)151 40171895',
  email: 'E Mail: hello@tafelberg-nuernberg.de'
};

export const defaultNewSection = {
  stackedText: ['MÖGL', 'ICHKE', 'ITSRA', 'UM'],
  textColor: '#000000'
};

export const defaultHero = {
  title: {
    de: 'T A F E L B E R G',
    en: 'T A F E L B E R G'
  },
  subtitle: {
    de: 'Denkmalanders',
    en: 'Monumental'
  },
  image: 'https://res.cloudinary.com/dqssg8tws/image/upload/v1769899188/hero_wfidig.png',
  backgroundColor: '#000000',
  textColor: '#ffffff'
};

export const defaultGlobalColors = {
  titleColor: '#fff',
  textColor: '#fff',
  sectionTitleColor: '#ffffff',
  bodyTextColor: '#ffffff',
  artSectionTextColor: '#000000',
  artSectionRemainingTextColor: '#000000',
  heroTextColor: '#ffffff',
  contactTextColor: '#fff'
};

export const defaultNewsletter = {
  title: 'Tafelberg Newsletter',
  subject: 'Latest Updates from Tafelberg',
  content: 'Welcome to our newsletter! Stay updated with the latest news and events.',
  fromEmail: 'newsletter@tafelberg-nuernberg.de',
  apiKey: '',
  subscribers: [],
  autoSend: false,
  sendFrequency: 'monthly'
};

export const defaultEventsSection = {
  headerTitle: { de: 'Upcoming Events', en: 'Upcoming Events' },
  headerSubtitle: { de: 'Aktuelle Termine und Highlights', en: 'Current dates and highlights' },
  events: [
    { id: 1, title: { de: 'Eröffnung', en: 'Opening' }, date: '', description: { de: 'Eröffnungstext', en: 'Opening text' }, image: '' }
  ]
};
